import Image from 'next/image'
import { useState } from 'react'

import { Card } from '@wartek-id/card'
import { Text } from '@wartek-id/text-v1'
import { Badge } from '@wartek-id/badge'
import { Icon } from '@wartek-id/icon-v2'
import { Shimmer } from '@wartek-id/shimmer'

import { CardSchool } from '../CardSchool'
import { PENGELOLAAN_KINERJA_KS_PENILAI_PATH } from 'app/KinerjaShared/constants/path'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { DialogPltKSConfirmation } from '../DialogPltKSConfirmation'
import { PANDUAN_PENGELOLAAN_URL } from 'app/KinerjaShared/utils/panduan'

import type { PelaksanaanSchool } from 'types/kinerja-pelaksanaan'

interface CardKinerjaPeriksaMultipleSchoolProps {
  isLoading?: boolean
  schools: PelaksanaanSchool[]
}

export default function CardKinerjaPeriksaMultipleSchool({
  isLoading = false,
  schools,
}: CardKinerjaPeriksaMultipleSchoolProps) {
  const { periodNo } = usePeriodContext()
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false)

  return (
    <>
      <Card className="p-6">
        <div className="flex gap-6">
          <Image
            alt="Periksa Perencanaan Kinerja guru"
            src="/icon/typing-monitor.png"
            width={84}
            height={84}
          />
          <div className="flex-1 flex flex-col gap-1 justify-center">
            <Text
              variant="subheading"
              color="informational"
              className="!text-blue-60 !uppercase tracking-[0.5px]"
            >
              {periodNo === 1 ? '1-31 Januari' : '1-31 Juli'}
            </Text>
            <div className="flex items-center gap-2">
              <Text variant="heading-lg">Periksa Perencanaan Kinerja guru</Text>
              <Badge className="uppercase whitespace-nowrap">
                Khusus Kepala Sekolah
              </Badge>
            </div>
            <Text color="subdued">
              Mohon cek dan setujui. Anda juga bisa memberikan penyesuaian jika
              diperlukan.
            </Text>
          </div>
        </div>
        <div className="grid grid-cols-[repeat(auto-fill,minmax(400px,1fr))] pt-6 gap-6">
          {isLoading ? (
            <>
              <Shimmer height="120px" width="100%" />
              <Shimmer height="120px" width="100%" />
            </>
          ) : (
            schools.map((school) => (
              <CardSchool
                key={school.npsn}
                baseHref={`${PENGELOLAAN_KINERJA_KS_PENILAI_PATH}/periksa`}
                ctaText="Periksa"
                school={school}
                checkConfirmation
                onClick={() => {
                  if (school.confirmationStatus === 'REJECTED') {
                    setShowConfirmationDialog(true)
                  }
                }}
              />
            ))
          )}
        </div>
        <div className="rounded bg-cyan-5 p-3 mt-6 flex items-center">
          <Icon color="informational" className="mr-1">
            error
          </Icon>
          Jika satuan pendidikan tidak sesuai, mohon kunjungi&nbsp;
          <a
            className="!text-blue-70 underline"
            href={PANDUAN_PENGELOLAAN_URL}
            target="_blank"
            rel="noreferrer"
          >
            Pusat Bantuan
          </a>
          .
        </div>
      </Card>

      <DialogPltKSConfirmation
        isOpen={showConfirmationDialog}
        onClose={() => setShowConfirmationDialog(false)}
      />
    </>
  )
}
